import React from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Image, Video, ExternalLink, Trash2, X, ChevronLeft, ChevronRight, Play } from 'lucide-react';

const Header = () => {
    const navigate = useNavigate();

    return (
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1rem" }}>
            <h1>Feed Generator</h1>
            <nav style={{ display: "flex", gap: "1rem" }}>
                <button onClick={() => navigate("/link")}>JSON to Links</button>
                <button onClick={() => navigate("/")}>Links to Feed</button>
            </nav>
        </header>
    );
};

export default Header;